<script setup>
import { ref } from 'vue'
import BcsCopies from '../shared/components/CopyManager/BcsCopies.vue'
import QuestionsManager from '../shared/components/CopyManager/QuestionsManager.vue'

import BcsTooltip from '../shared/components/BcsTooltip.vue'

const tabs = [
  {
    label: 'Bcs Copy',
    tooltip: '<strong>What is this searching?</strong> <br /> Collections of descriptions, definitions, and other text throughout the BCS Pro application.'
  },
  {
    label: 'Questions',
    tooltip: 'These are the questions in the Assessment, as well as the discussion points in the Planning Guide.'
  }
]

const myTabContent = ref(null)
const ulParent = ref(null)
const totalCopies = ref(0)
const totalQuestions = ref(0)

function showContentTab(tabIndex) {
  const tabButtons = ulParent.value?.querySelectorAll('.nav-link')
  const tabPanes = myTabContent.value?.querySelectorAll('.tab-pane')

  if (tabButtons && tabPanes) {
    tabButtons.forEach((button) => {
      button.classList.remove('active')
    })
    tabPanes.forEach((pane) => {
      pane.classList.remove('show', 'active')
    })

    tabButtons[tabIndex].classList.add('active')
    tabPanes[tabIndex].classList.add('show', 'active')
  }
}

function handleTotalCopiesUpdate(total) {
  totalCopies.value = total
}

function handleTotalQuestionsUpdate(total) {
  totalQuestions.value = total
}
</script>

<template>
  <div class="copy-manager-container d-flex justify-content-center">
    <div class="copy-manager-content">
      <h1 class="mt-3 text-center">Copy Manager</h1>
      <p class="text-center text-14">
        This BCS Pro Copy manager tool is to be used by select BCS employees for updating copy on the live, production version of the BCS Pro application.
        <br>
        <strong>Be very, very careful in what you update, when, and how.</strong>
        <br>
        Updates are only to be made before or after business hours, so as to not interrupt any active users, and to minimize the risk of adverse impacts to our customers.
      </p>

      <div class="container-fluid px-0">
        <div class="sticky-top bg-white">
          <!-- Tabs navigation -->
          <div class="d-flex pt-3">
            <ul class="nav nav-tabs" id="myTab" role="tablist" ref="ulParent">
              <li
                v-for="(tab, tabIndex) in tabs"
                class="nav-item"
                :class="{ 'ps-4': tabIndex === 0 }"
                role="presentation"
                :key="tabIndex">
                <BcsTooltip :simpleText="tab.tooltip" :show-arrow="true" :contentClass="'simple-text-tooltip'">
                  <button
                  class="nav-link border-top border-end border-start"
                  :class="{ active: tabIndex === 0 }"
                  :id="`tab-${tabIndex}`"
                  @click="showContentTab(tabIndex)"
                  data-bs-toggle="tab"
                  :data-bs-target="`#tab-pane-${tabIndex}`"
                  type="button"
                  role="tab"
                  :aria-controls="`tab-pane-${tabIndex}`"
                  :aria-selected="tabIndex === 0">
                  {{ tab.label }}
                  <span v-if="tabIndex === 0" class="badge bg-primary ms-2">{{ totalCopies }}</span>
                  <span v-if="tabIndex === 1" class="badge bg-primary ms-2">{{ totalQuestions }}</span>
                </button>
                </BcsTooltip>
              </li>
            </ul>
            <div class="planning-header-line"></div>
          </div>
        </div>

        <!-- Tab content -->
        <div class="container-fluid">
          <div class="tab-content" id="myTabContent" ref="myTabContent">
            <!-- BCS Copies Tab -->
            <div
              class="tab-pane fade show active"
              id="tab-pane-0"
              role="tabpanel"
              aria-labelledby="tab-0"
              tabindex="0">
              <BcsCopies @update:totalCopies="handleTotalCopiesUpdate" />
            </div>

            <!-- Questions Tab -->
            <div
              class="tab-pane fade"
              id="tab-pane-1"
              role="tabpanel"
              aria-labelledby="tab-1"
              tabindex="0">
              <QuestionsManager @update:totalQuestions="handleTotalQuestionsUpdate" />
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.copy-manager-content {
  width: 95%;
  max-width: 1600px;
}

.planning-header-line {
  flex-grow: 1;
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}

.title-tab-container {
  padding: 20px 0;
}

.tab-content-placeholder {
  min-height: 300px;
  background-color: #f8f9fa;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-22 {
  font-size: 1.375rem;
}
  /* Show \n as line breaks inside tooltips */
  ::v-deep(.tooltip-body) {
    white-space: pre-line;
  }

  /* Bold first line only for the first tab (Bcs Copy) */
  ::v-deep(#myTab li:first-child .tooltip-body)::first-line {
    font-weight: 700;
  }
</style>